import { Form } from "../../../system/useForm";
import { DeliveryType, VehicleAddresses } from "../../../system/Domain";
import { EditMode } from "./ReturnOrdersForm";
import { Box, Grid, InputAdornment, Typography } from "@mui/material";
import FormChoices from "../../../Components/FormChoices";
import FormText from "../../../Components/FormText";
import { useEffect } from "react";
import FormYesNo from "../../../Components/FormYesNo";

interface Props {
	form: Form;
	addresses: VehicleAddresses;
	editMode: EditMode;
}

const StepAdditional = (props: Props) => {
	const entryType = props.form.getValue("delivery.deliveryType") ?? "";
	const isCustomerDelivery = entryType === DeliveryType.CustomerDelivery;
	const isRkv = props.addresses.isRkv;
	const isPoolfleet = props.form.getValue("isPoolfleet");
	const isCompoundDelivery = entryType === DeliveryType.UsedCars;

	useEffect(() => {
		const salesType = props.form.getValue("salesType");

		if (isPoolfleet) {
			props.form.setValue("salesType", "Flex");
		} else if (isRkv) {
			props.form.setValue("salesType", "Rkv");
		} else if (isCustomerDelivery) {
			props.form.setValue("salesType", "Sale");
		} else if (!isCompoundDelivery) {
			props.form.setValue("salesType", "NoSale");
		} else if (salesType === "Flex" || salesType === "Rkv") {
			props.form.setValue("salesType", undefined);
		}
	}, [isPoolfleet, isRkv]);

	const salesTypeChoices = () => {
		if (isRkv) return { Rkv: "Rkv" };
		if (isPoolfleet) return { Flex: "Flex" };

		return { Sale: "Ja", NoSale: "Nein" };
	};

	return (
		<Box mb={2} mt={2}>
			<Grid container spacing={2}>
				<FormChoices
					name="salesType"
					label={isRkv || isPoolfleet ? "Verkaufstyp" : "Frei zum Verkauf"}
					form={props.form}
					options={{ required: true }}
					choices={salesTypeChoices()}
					disabled={isRkv || isPoolfleet}
				/>
				{props.form.getValue("salesType") === "NoSale" && isCompoundDelivery && (
					<FormText
						name="salesTypeComment"
						form={props.form}
						label="Verkaufskommentar"
						type="text"
						options={{ required: true }}
					/>
				)}
				{props.form.getValue("isRegistered") === true && (
					<FormYesNo
						name="doUnregistration"
						label="Soll das Auto abgemeldet werden?"
						form={props.form}
						options={{
							required: true,
						}}
					/>
				)}
				<Typography variant="h6" gutterBottom sx={{ marginTop: 8 }}>
					Kostenverteilung
				</Typography>
				<FormText
					name="transportCostInstallments"
					form={props.form}
					label="Transportkosten in Rate kalkuliert"
					type="number"
					startAdornment={<InputAdornment position="start">€</InputAdornment>}
				/>
				<FormText
					name="costTransferCustomer"
					form={props.form}
					label="Weiterbelastung an Kunden"
					type="number"
					startAdornment={<InputAdornment position="start">€</InputAdornment>}
				/>
				<FormText
					name="debitingAld"
					form={props.form}
					label="Kosten zu Lasten ALD"
					type="number"
					startAdornment={<InputAdornment position="start">€</InputAdornment>}
				/>
				<FormText
					name="carryoverCost"
					form={props.form}
					label="Kundenverschuldete Zusatzkosten"
					type="number"
					startAdornment={<InputAdornment position="start">€</InputAdornment>}
				/>
			</Grid>
		</Box>
	);
};

export default StepAdditional;
